import React from 'react'
import { Create } from 'react-admin'
import Form from './form'

const TonnageRatesCreate = props => {
  return (
    <Create {...props}>
      <Form />
    </Create>
  )
}

export default TonnageRatesCreate
